var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('complex-write01',{on:{"save":_vm.onClickSave,"delete":_vm.onClickDelete,"moveList":_vm.onClickMoveList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }